/**
 * Collapsible options group
 * Used by the _product-form-collapsible-group block. The open/close behavior is native <details>,
 * this component only populates the summary with the labels of the options inside it.
 * The open state is kept across variant re-renders in product-form.js (syncCollapsibleGroups).
 */
class CollapsibleOptionsGroup extends HTMLElement {
  connectedCallback() {
    this.details = this.closest('details');
    this.labelsPlaceholder = this.details?.querySelector('[data-collapsible-options-labels]');
    if (!this.details || !this.labelsPlaceholder) return;

    this.populateLabels();

    // Open the group when a nested block is selected in the theme editor
    this.onBlockSelect = (event) => {
      if (this.contains(event.target)) this.details.open = true;
    };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  /**
   * Populate the summary with the labels of the visible options,
   * hide the whole group when no option is visible for this product
   */
  populateLabels() {
    const labels = [...this.querySelectorAll('[data-option-label]')]
      .filter((label) => this.isVisible(label))
      .map((label) => label.textContent.trim())
      .filter(Boolean);
    const uniqueLabels = [...new Set(labels)];

    this.labelsPlaceholder.textContent = uniqueLabels.join(' | ');
    this.details.hidden = uniqueLabels.length === 0 && !window.Shopify?.designMode;
  }

  /**
   * Check if an element is visible, stops at the group itself because the closed
   * details content is not rendered
   * @param {HTMLElement} element
   * @returns {Boolean}
   */
  isVisible(element) {
    for (let node = element; node && node !== this; node = node.parentElement) {
      if (getComputedStyle(node).display === 'none') return false;
    }
    return true;
  }
}

customElements.define('collapsible-options-group', CollapsibleOptionsGroup);
